import { useEffect, useRef } from "react";
import usePasskey from "../Service/hooks/usePasskey";


export default function PasskeyRegistrationMessage({ onCancel }) {
   

    // const iosFirstCondition = !passkeyRegistrationIOS;
    return <div className="flex flex-col gap-3">
        <p className="text-lg">Inloggen met passkey</p>
        <p>
            Log vanaf nu in zoals je gewend bent, met gezichtsherkenning, vingerafdruk of code
        </p>
        <PasskeyRegistrationButton />
        { onCancel && <button className="p-2 bg-red-500 text-white" onClick={() => onCancel()}>Nee, niet nu</button> }
        {/* <label className="flex flex-row gap-3 p-2 border" onClick={(e) => setDontAskAgain((x) => !x)}>
            <input type="checkbox" value={dontAskAgain} />
            <span className="">In de toekomst niet meer vragen</span>
        </label> */}
    </div>
}

export function PasskeyRegistrationButton({ label = 'Ja, stel in' }) {


    const { startPasskeyRegistration } = usePasskey();

    const registrationButton = useRef(null);

    useEffect(() => {
        let abortController = new AbortController();
        let signal = abortController.signal;

        registrationButton.current.addEventListener('click', async () => {

            let result = await startPasskeyRegistration();
            return true;
        }, signal);


        return () => {
            abortController.abort();        }

    }, [])

    return  <button className="p-2 bg-blue-500 text-white disabled:bg-red-500" ref={registrationButton}>{label}</button>
}